/**
 * Single source for Angular clients (MAS, dashboard, kiosk). Cloud Functions use the same DB id in
 * `functions/src/modules/firebase.module.ts` (`ENTERPRISE_FIRESTORE_DATABASE_ID`).
 *
 * Keep in sync with repo root `firebase.json`:
 * - `emulators.auth.port`, `firestore.port`, `functions.port`, `storage.port`
 * - single `firestore` entry using database id `default`
 *
 * **Production (cloud):** Firestore database id is `default` (enterprise named DB — not the same as `(default)`).
 *
 * **Emulator:** After a `gcloud firestore export` import (`--seed_from_export`), data usually appears under the
 * emulator’s classic default slot, which the Emulator UI labels `(default)`. The JS SDK database id for that
 * slot is the string `(default)`. Use this for `initializeFirestore(..., emulatorDbId)` so localhost matches
 * where the import landed; keep `FIRESTORE_DATABASE_ID` as `default` for real cloud.
 */
export const FIRESTORE_DATABASE_ID = 'default';

/** Firestore database id used only when connecting to the local Firestore emulator. */
export const FIRESTORE_EMULATOR_DATABASE_ID = 'default';

export const FIREBASE_EMULATOR_HOST = 'localhost';

export const FIREBASE_EMULATOR_PORTS = {
	auth: 9099,
	firestore: 8089,
	functions: 5001,
	storage: 9199,
} as const;
